/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Import_Status_Queued_AfterInputs */

const en_import_status_queued_after = /** @type {(inputs: Import_Status_Queued_AfterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Queued · starts after ${i?.count} other`)
};

const de_import_status_queued_after = /** @type {(inputs: Import_Status_Queued_AfterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wartet · startet nach ${i?.count} anderen`)
};

/**
* | output |
* | --- |
* | "Queued · starts after {count} other" |
*
* @param {Import_Status_Queued_AfterInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_status_queued_after = /** @type {((inputs: Import_Status_Queued_AfterInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Status_Queued_AfterInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_status_queued_after(inputs)
	return en_import_status_queued_after(inputs)
});